<template>
    <div>
    <Modal :is_show="is_show" @click-bg="emit('close','social_account')" class="add-creator-modal add-social-modal edit-program-set-pop" >
        <header class="edit_program_header">
            Social Account
            <Switch :checked="true" @click.native="is_show_alert_modal=true;" />
            <i @click="emit('close','social_account')"><svg-icon name="close" /></i>
        </header>

        <Scrollbar class="edit-scroll-list" :show_bar="true" v-if="handle_data.length>0">
            <div class="edit_program_body">
                <div class="head-spec">
                    <div class="desc-title">Please indicate how you would like to collect social media information from your applicants. Social authentication is the most accurate way to verify a creator's identity. If social authentication is disabled, you cannot import insights or data.</div>
                </div>

                <div class="box question-templeat">
                    <div class="question-templeat-top">
                        <div class="desc">Main social</div>
                        <div class="req-box" @click="handleIsReq()">
                            <Checkbox :checked="handle_data[ind.required_at_least_1.i].is_required" />
                            {{handle_data[ind.required_at_least_1.i].name}}
                        </div>
                    </div>

                    <!-- question top-->
                    <div class="edit-item" v-for="(v, k) in handle_data.filter(e=>{return e.group_name ==='tikTok' || e.group_name==='instagram' })" :key="k">
                        <div class="line">
                            <div class="name">{{ v.name }}</div>
                            <div class="handle_req">
                                <div :class="['req-box', handle_data[ind.required_at_least_1.i].is_required && 'disab-req-box']" v-if="v.is_switch" @click="v.is_required = handle_data[ind.required_at_least_1.i].is_required? false : !v.is_required" >
                                    <Checkbox :checked="v.is_required" :disabled="handle_data[ind.required_at_least_1.i].is_required"/>
                                    Required
                                </div>
                                <Switch :checked="v.is_switch" @click.native="v.is_switch = handle_data[ind.required_at_least_1.i].is_required ? true : !v.is_switch ; v.is_required = !v.is_switch?false:v.is_required ;" />
                            </div>
                        </div>
                        <!-- **question group** -->
                        <div class="group" v-if="v.is_switch">
                            <div class="edit-item" v-for="(vv, kk) in v.question.filter(e=>{return !e.not_in_set})" :key="kk">
                                <div :class="['line', (kk == 1 && !v.question[0].show ) && 'disabeld-line', {'color-gray' : !vv.show}]">
                                    <div class="name">{{ vv.name }}</div>
                                    <Switch :checked="vv.show" @click.native="handleConnetSwitch( vv, k+1 ,kk)" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- more question -->
                    <div class="hr"></div>
                    <div class="desc desc-other">Other links:</div>

                    <div class="show-qu">
                        <div class="edit-item" v-for="(v, k) in handle_data.filter(e=>{return e.group_name !=='tikTok' && e.group_name!=='instagram' && e.group_name!=='required_at_least_1'})" :key="k" v-show="v.can_edit">
                            <div class="line">
                                <div class="name">{{ v.name }}</div>
                                <div class="handle_req" >
                                    <div class="req-box" v-if="v.is_switch" @click="v.is_required = v.is_required ? false : true">
                                        <Checkbox :checked="v.is_required" />
                                        Required
                                    </div>
                                    <Switch :checked="v.is_switch" @click.native="v.is_switch = v.is_switch? false : true" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Scrollbar>
        <!-- save -->
        <div class="save-btn-box">
            <el-button type="primary" size="large" class="save-btn" @click="save">Save</el-button>
        </div>
    </Modal>

    <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
            <div class="box">
                <header class="delete-header">Hide section?</header>
                <p>Applicants will no longer be able to view any question(s) that appear under this section. To make visible again, use the + SECTION button</p>
                <div class="btns">
                    <el-button @click="is_show_alert_modal = false">No</el-button>
                    <el-button type="primary" @click="is_show_alert_modal = false; emit('hide'); emit('close','social_account')">Confirm</el-button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import Modal from '@/components/ui/Modal.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import { getIndex } from '@/utils/ProgramsData.js';
import { ElButton } from 'element-plus';

const props = defineProps({
    is_show: { type: Boolean, default: true },
    data: { type: Array, default: () => [] },
    is_edit: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'save', 'hide']);

const handle_data = ref([]);
const is_show_alert_modal = ref(false);
const ind = reactive({
    required_at_least_1: { i: 0, ii: 0 },
});

const handleConnetSwitch = (vv, k, kk) => {
    vv.show = !vv.show;
    if (kk === 0 && !handle_data.value[k].question[0].show) {
        handle_data.value[k].question[1].show = false;
    }
};

const handleIsReq = () => {
    handle_data.value[ind.required_at_least_1.i].is_required = !handle_data.value[ind.required_at_least_1.i].is_required;
    if (handle_data.value[ind.required_at_least_1.i].is_required) {
        handle_data.value.forEach(e => {
            if (e.group_name === 'tikTok' || e.group_name === 'instagram') {
                e.is_switch = true;
                e.is_required = false;
            }
        });
    }
};

const handleData = () => {
    handle_data.value.forEach(e => {
        if (e.group_name === 'tikTok' || e.group_name === 'instagram') {
            e.question.forEach(ee => {
                if (ee.set_handle && !ee.show) {
                    e.connect.client_view.client_type = 'url-handle';
                } else if (ee.set_handle && ee.show) {
                    e.connect.client_view.client_type = 'connect';
                }
            });
            e.question.forEach(ee => {
                if (ee.label === 'tikTok_url' || ee.label === 'instagram_url') {
                    ee.show = e.connect.client_view.client_type === 'url-handle';
                }
            });
        } else if (e.group_name !== 'required_at_least_1') {
            e.question.forEach(ee => {
                ee.show = e.is_switch;
            });
        }
    });
};

const save = () => {
    handleData();
    emit('save', { data: handle_data.value, type: 'social_account' });
};

onMounted(() => {
    ind.required_at_least_1 = getIndex(props.data, 'required_at_least_1', 'required_at_least_1');
    handle_data.value = JSON.parse(JSON.stringify(props.data));
    console.log('handle_data', handle_data.value);
});
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.add-social-modal {
    header{
        @include flexCenter();
        justify-content: space-between;

        .ui-switch{
            margin-right: 40px;
        }
    }

    .head-spec{
        width: -100%;
        padding-bottom: 24px;
        border-bottom: solid 1px var(--gray-blue);
    }

    .question-templeat-top{
        @include flexCenter();
        justify-content: space-between;
        margin: 8px 0;
    }

    .req-box{
        @include flexCenter();
        cursor: pointer;
        color:var(--black-90);

        .ui-checkbox{
            margin:unset;
        }

        &.disab-req-box{
            color:var(--black-40);
            cursor: default !important;
        }
    }

    .edit-item{
      margin: 0 0 8px !important;

      .line{
        margin-bottom: 8px;

        &.disabeld-line{
            opacity: .5;
            pointer-events: none;
        }
      }
    }

    .hr{
        margin: 16px 0px 8px;
    }

    .desc-title{
        font-size:12px;
        color:var(--black-75);
    }

    .desc-other{
        margin-bottom: 12px;
    }
}
</style>
